import { MessagePreviewProps } from "./types"
import React from "react"
import { MessageTypes } from "../../proto"
import MessagePreviewDraft from "./components/message-preview-draft"
import MessagePreviewVoice from "./components/message-preview-voice"
import MessagePreviewFile from "./components/message-preview-file"
import MessagePreviewImage from "./components/message-preview-image"
import MessagePreviewVideo from "./components/message-preview-video"
import MessagePreviewImages from "./components/message-preview-images"
import MessagePreviewMention from "./components/message-preview-mention"
import MessagePreviewText from "./components/message-preview-text"
import MessagePreviewOrder from "./components/message-preview-order"
import MessagePreviewTrans from "./components/message-preview-trans"
import MessagePreviewRed from "./components/message-preview-red"
import MessagePreviewShare from "./components/message-preview-share"
import MessagePreviewLottery from "./components/message-preview-lottery"
import styled from '~/ui/styled'
import { useStores } from "../../models"
import { formatMentionId } from "../../utils/format"

const Container = styled.View`
  width: 70%;
  margin-top: 5px;
`

export const MessagePreview: React.FC<MessagePreviewProps> = ({
  message,
  draft,
  chatTypeEnum,
  isUnread,
}) => {
  const { userStore } = useStores()
  const forwardPrependMsg = message?.forward_msg_id ? `转发来自${message.forward_name}: ` : ""
  const senderName = message?.sender?.name
  const isMe = userStore.currentUser.id === message?.sender?.id
  const renderMessage = () => {
    switch (message.type) {
      case MessageTypes.TEXT:
        return (
          <MessagePreviewText
            senderName={chatTypeEnum === "GROUP" && senderName && !isMe ? `${senderName}:` : ""}
            forwardPrependMsg={forwardPrependMsg}
            content={formatMentionId(message?.content, message?.mention_ids, userStore)}
          ></MessagePreviewText>
        )
      case MessageTypes.IMAGE:
        return <MessagePreviewImage forwardPrependMsg={forwardPrependMsg}></MessagePreviewImage>
      case MessageTypes.VIDEO:
        return <MessagePreviewVideo forwardPrependMsg={forwardPrependMsg}></MessagePreviewVideo>
      case MessageTypes.IMAGES:
        return (
          <MessagePreviewImages
            forwardPrependMsg={forwardPrependMsg}
            length={message?.attach?.imgs?.length || 0}
          ></MessagePreviewImages>
        )
      case MessageTypes.VOICE:
        return <MessagePreviewVoice forwardPrependMsg={forwardPrependMsg}></MessagePreviewVoice>
      case MessageTypes.FILE:
        return <MessagePreviewFile forwardPrependMsg={forwardPrependMsg}></MessagePreviewFile>
      case MessageTypes.ORDER:
        return (
          <MessagePreviewOrder
            senderName={chatTypeEnum === "GROUP" && senderName && !isMe ? `${senderName}:` : ""}
            forwardPrependMsg={forwardPrependMsg}
            content={formatMentionId(message?.content, message?.mention_ids, userStore)}
            message={message}
          ></MessagePreviewOrder>
        )
      case MessageTypes.NEW_TRANS:
        return (
          <MessagePreviewTrans
            senderName={chatTypeEnum === "GROUP" && senderName && !isMe ? `${senderName}:` : ""}
            forwardPrependMsg={forwardPrependMsg}
            content={formatMentionId(message?.content, message?.mention_ids, userStore)}
            message={message}
          ></MessagePreviewTrans>
        )
        case MessageTypes.RED_PACKET:
          return (
            <MessagePreviewRed
              senderName={chatTypeEnum === "GROUP" && senderName && !isMe ? `${senderName}:` : ""}
              forwardPrependMsg={forwardPrependMsg}
              content={formatMentionId(message?.content, message?.mention_ids, userStore)}
              message={message}
            ></MessagePreviewRed>
          )
          case MessageTypes.SHARE_CARD:
            return (
              <MessagePreviewShare
                senderName={chatTypeEnum === "GROUP" && senderName && !isMe ? `${senderName}:` : ""}
                forwardPrependMsg={forwardPrependMsg}
                content={`来自${message?.content}的名片`}
              ></MessagePreviewShare>
            )
          case MessageTypes.GAME_NOTICE:
            return <MessagePreviewLottery forwardPrependMsg={forwardPrependMsg}></MessagePreviewLottery>
      default:
        return null
    }
  }
  const hasMentioned = message?.mention_ids.some((i) => i === userStore.currentUser.id)
  const mentionedContent = formatMentionId(message?.content, message?.mention_ids, userStore)
  return (
    <Container>
      {draft ? (
        <MessagePreviewDraft draft={draft} />
      ) : hasMentioned ? (
        <MessagePreviewMention content={mentionedContent} isUnread={isUnread} />
      ) : message ? (
        renderMessage()
      ) : null}
    </Container>
  )
}
